import { render } from "./Navigation.vue?vue&type=template&id=01a2cd6a&scoped=true"
const script = {}

import "./Navigation.vue?vue&type=style&index=0&id=01a2cd6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a2cd6a"]])

export default __exports__